import authBaseAxios from "../utils/api";
import { IAuditLogResponse } from "../interfaces/audit-log";

export const AuditLogServices = {
  getAuditLogs: (params: any): Promise<IAuditLogResponse> => {
    return authBaseAxios.get(`audit-logs`, params);
  },
};
